import { TableCell, TableRow } from '@mui/material';
import React from 'react';

import { ContactItemDto } from '@/api/generated';
import { TableRowLink } from '@/components/table/components/TableRowLink.comp.tsx';
import { useDictionariesContext } from '@/contexts/dictionaries/Dictionaries.context.ts';
import { formatDate } from '@/utils/formatDate.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

type Props = {
  actions?: React.ReactNode;
  detailsTo?: string;
  onCustomAction?: ((row: ContactItemDto) => Promise<void> | void) | undefined;
  onRowClick: (() => void) | undefined;
  row: ContactItemDto;
};

export const ContactsTableRowCommon: React.FC<Props> = props => {
  const { actions, detailsTo, onCustomAction, onRowClick, row } = props;
  const { t } = useTranslationWithPrefix('views.contacts.table.row');
  const { USERS_SHORT } = useDictionariesContext();
  const owner = USERS_SHORT.find(user => user.value === row.contactOwnerId);

  const handleClick = async () => {
    if (onCustomAction) {
      await onCustomAction(row);
      return;
    }
    onRowClick?.();
  };

  return (
    <TableRow
      hover
      onClick={handleClick}
      sx={{ cursor: onRowClick || onCustomAction ? 'pointer' : 'default' }}
    >
      <TableCell>{row.lastName}</TableCell>
      <TableCell>{row.firstName}</TableCell>
      <TableCell>
        {detailsTo && !onCustomAction ? (
          <TableRowLink to={detailsTo}>{row.name}</TableRowLink>
        ) : (
          row.name
        )}
      </TableCell>
      <TableCell>{row.customer?.name}</TableCell>
      <TableCell>{owner?.label}</TableCell>
      <TableCell>{formatDate(row.lastContactedAt)}</TableCell>
      <TableCell>{t(`statusOptions.${row.status}`)}</TableCell>
      {actions && <TableCell>{actions}</TableCell>}
    </TableRow>
  );
};
